import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {Button, Card} from 'antd';
import {getRegulatoryReportingTypes} from './actions';
import ResponsiveTable from "../common/ResponsiveTable";

const columns = [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name'
  },
  {
    title: 'Unit Of Measure Class',
    dataIndex: 'unitOfMeasureClass',
    key: 'unitOfMeasureClass'
  }
];

class RegulatoryReportingTypesPage extends Component {
  componentDidMount() {
    this._load();
  }

  _load = (newPagination) => {
    //const {pagination} = this.props;
    this.props.getRegulatoryReportingTypes();
  };

  handleSet = e => {
    e.preventDefault();
    this.props.history.push('/regulatory-reporting/add-type');
  };

  render() {
    const {loading, regulatoryReportingTypes} = this.props;
    return (
      <Card title="Regulatory Reporting Types" extra={<Button type="primary" icon="plus" onClick={this.handleSet}>Add</Button>}>
        <ResponsiveTable
          loading={loading}
          columns={columns}
          dataSource={regulatoryReportingTypes}
          rowKey="regulatoryReportingTypeId"
          onChange={this._load}
        />
      </Card>
    );
  }
}

RegulatoryReportingTypesPage.propTypes = {
  history: PropTypes.object.isRequired,
  getRegulatoryReportingTypes: PropTypes.func.isRequired,
  regulatoryReportingTypes: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  regulatoryReportingTypes: state.regulatoryReportingType.regulatoryReportingTypes,
  loading: state.regulatoryReportingType.regulatoryReportingTypesLoading,
});

const mapDispatchToProps = dispatch => ({
  getRegulatoryReportingTypes: (payload) => (dispatch(getRegulatoryReportingTypes(payload)))
});

export default connect(mapStateToProps, mapDispatchToProps)(RegulatoryReportingTypesPage);



// WEBPACK FOOTER //
// ./src/RegulatoryReporting/RegulatoryReportingTypesPage.js